import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple approaches to ensure scroll to top works on all devices
    
    // Method 1: Immediate scroll
    window.scrollTo(0, 0);
    
    // Method 2: Using modern scroll API with fallback
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    } catch (e) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
    
    // Method 3: Force scroll after a short delay for mobile devices
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    // Method 4: Additional delay for stubborn mobile browsers
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
  }, [pathname]);

  // Also handle component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
